(function () {
  'use strict';

  if (window.__cartRecoControllerInstalled) return;
  window.__cartRecoControllerInstalled = true;


  /* ============================================================
     PART 1
     CART CHANGE BRIDGE
  ============================================================ */

  var CART_ENDPOINTS = [
    '/cart/add',
    '/cart/change',
    '/cart/update',
    '/cart/clear'
  ];

  function isCartEndpoint(url) {
    if (!url) return false;

    return CART_ENDPOINTS.some(function (ep) {
      return String(url).indexOf(ep) !== -1;
    });
  }


  function broadcastCartUpdate() {

    fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: {
              cart: cart
            }
          })
        );

      })
      .catch(function () {});
  }


  /* ============================================================
     FETCH HOOK
  ============================================================ */

  var originalFetch = window.fetch;

  window.fetch = function (input, init) {

    var url =
      typeof input === 'string'
        ? input
        : (input && input.url) || '';

    var method =
      (init && init.method) ||
      (typeof input !== 'string' && input && input.method) ||
      'GET';

    var isMutating =
      isCartEndpoint(url) &&
      String(method).toUpperCase() !== 'GET';

    var promise = originalFetch.apply(this, arguments);

    if (isMutating) {

      promise.then(function () {

        setTimeout(
          broadcastCartUpdate,
          80
        );

      });
    }

    return promise;
  };


  /* ============================================================
     XHR HOOK
  ============================================================ */

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;


  XMLHttpRequest.prototype.open = function (method, url) {

    this.__cartBridgeUrl = url;
    this.__cartBridgeMethod = method;

    return originalOpen.apply(
      this,
      arguments
    );
  };


  XMLHttpRequest.prototype.send = function () {

    var xhr = this;

    if (
      isCartEndpoint(xhr.__cartBridgeUrl) &&
      xhr.__cartBridgeMethod &&
      String(xhr.__cartBridgeMethod).toUpperCase() !== 'GET'
    ) {

      xhr.addEventListener(
        'load',
        function () {

          setTimeout(
            broadcastCartUpdate,
            80
          );

        }
      );
    }

    return originalSend.apply(
      this,
      arguments
    );
  };


  window.cartBridge = {
    broadcast: broadcastCartUpdate
  };


  /* ============================================================
     PART 2
     CART DRAWER RENDER HOOK
  ============================================================ */

  function hookCartDrawerRender() {

    var CartDrawerClass =
      window.customElements &&
      customElements.get('cart-drawer');

    if (
      !CartDrawerClass ||
      CartDrawerClass.prototype.__recoHooked
    ) {
      return;
    }


    var originalRenderContents =
      CartDrawerClass.prototype.renderContents;


    CartDrawerClass.prototype.renderContents =
      function (parsedState) {

        originalRenderContents.call(
          this,
          parsedState
        );

        setTimeout(
          function () {

            refreshFromServer(false);

          },
          60
        );
      };


    CartDrawerClass.prototype.__recoHooked = true;
  }


  /* ============================================================
     PART 3
     VARIABLES
  ============================================================ */

  var lastProductId = null;
  var lastSignature = null;

  var debounceTimer = null;
  var pollTimer = null;


  /* ============================================================
     DOM HELPERS
  ============================================================ */

  function getContainer() {

    return document.getElementById(
      'CartDrawerRecommendations'
    );
  }


  function getWrapper(container) {

    return container
      ? container.querySelector(
          '[data-cart-recommendations-wrapper]'
        )
      : null;
  }


  function getFallbackTemplate(container) {

    return container
      ? container.querySelector(
          '[data-cart-recommendations-fallback]'
        )
      : null;
  }


  /* ============================================================
     SHOW MANUAL COLLECTION
  ============================================================ */

  function renderFallback() {

    var container = getContainer();
    var wrapper = getWrapper(container);
    var template = getFallbackTemplate(container);


    if (
      !container ||
      !wrapper ||
      !template
    ) {
      return;
    }


    var fallbackContent =
      template.content.cloneNode(true);


    wrapper.innerHTML = '';

    wrapper.appendChild(
      fallbackContent
    );


    /*
      Manual collection mil gayi
      to recommendation container visible rakho.
    */

    if (
      wrapper.children.length > 0
    ) {

      container.hidden = false;

    } else {

      container.hidden = true;

    }
  }


  /* ============================================================
     FORMAT MONEY
  ============================================================ */

  function formatMoney(cents) {

    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function' &&
      window.theme_money_format
    ) {

      return window.Shopify.formatMoney(
        cents,
        window.theme_money_format
      );
    }


    return '\u20B9' +
      (cents / 100).toFixed(0);
  }


  /* ============================================================
     PICK AVAILABLE VARIANT
  ============================================================ */

  function pickVariant(product) {

    var variants =
      product.variants || [];

    var available =
      variants.filter(function (v) {
        return v.available;
      });


    return available.length
      ? available[0]
      : (variants[0] || null);
  }


  /* ============================================================
     BUILD SMART RECOMMENDATION SLIDE
  ============================================================ */

  function buildSlide(product) {

    var image =
      (
        product.featured_image &&
        (
          product.featured_image.url ||
          product.featured_image
        )
      ) ||
      (
        product.images &&
        product.images[0]
      ) ||
      '';


    var title =
      product.title || '';


    var price =
      typeof product.price === 'number'
        ? formatMoney(product.price)
        : '';


    var variant =
      pickVariant(product);


    var soldOut =
      !variant ||
      variant.available === false;


    var slide =
      document.createElement('div');


    slide.className =
      'swiper-slide cart-reco__item';


    slide.innerHTML =

      '<a href="' +
        product.url +
        '" class="cart-reco__image-link">' +

        '<img src="' +
          image +
          '" alt="' +
          title.replace(
            /"/g,
            '&quot;'
          ) +
          '" loading="lazy" width="220" height="220">' +

      '</a>' +


      '<a href="' +
        product.url +
        '" class="cart-reco__title animation-underline">' +

        title +

      '</a>' +


      '<div class="cart-reco__row">' +

        (
          price
            ? '<div class="cart-reco__price">' +
                price +
              '</div>'
            : ''
        ) +

      '</div>' +


      '<div class="cart-reco__msg" data-reco-msg hidden></div>';


    return slide;
  }


  /* ============================================================
     SHOW SMART PRODUCTS
  ============================================================ */

  function renderSmart(products) {

    var container =
      getContainer();

    var wrapper =
      getWrapper(container);


    if (
      !container ||
      !wrapper
    ) {
      return;
    }


    /*
      IMPORTANT:
      Related products mil gaye,
      tab manual collection replace hogi.
    */

    wrapper.innerHTML = '';


    if (
      !products ||
      !products.length
    ) {

      /*
        No related products.
        Manual collection fallback.
      */

      renderFallback();

      return;
    }


    products
      .slice(0, 8)
      .forEach(function (product) {

        wrapper.appendChild(
          buildSlide(product)
        );

      });


    container.hidden = false;
  }


  /* ============================================================
     FETCH RELATED PRODUCTS
  ============================================================ */

  function fetchRecommendations(productId) {

    /*
      Agar product ID nahi hai,
      manual collection show karo.
    */

    if (!productId) {

      renderFallback();

      return;
    }


    fetch(
      '/recommendations/products.json?product_id=' +
      productId +
      '&limit=8&intent=related'
    )

      .then(function (res) {

        if (!res.ok) {
          throw new Error(
            'Recommendation API failed'
          );
        }

        return res.json();

      })


      .then(function (data) {

        var products =
          data &&
          data.products
            ? data.products
            : [];


        /*
          RELATED PRODUCTS AVAILABLE
          → Smart recommendations show

          RELATED PRODUCTS NOT AVAILABLE
          → Manual collection show
        */

        if (
          products &&
          products.length
        ) {

          renderSmart(products);

        } else {

          renderFallback();

        }

      })


      .catch(function () {

        /*
          API error bhi ho to
          manual collection fallback.
        */

        renderFallback();

      });
  }


  /* ============================================================
     CART SIGNATURE
  ============================================================ */

  function cartSignature(cart) {

    var items =
      (cart && cart.items) || [];


    return (
      cart.item_count +
      '|' +
      cart.total_price +
      '|' +
      items
        .map(function (i) {

          return (
            i.variant_id +
            ':' +
            i.quantity
          );

        })
        .join(',')
    );
  }


  /* ============================================================
     UPDATE RECOMMENDATIONS FROM CART
  ============================================================ */

  function updateFromCart(
    cart,
    force
  ) {

    var signature =
      cartSignature(cart);


    if (
      !force &&
      signature === lastSignature
    ) {
      return;
    }


    lastSignature =
      signature;


    var items =
      (cart && cart.items) || [];


    /*
      CART EMPTY
      → Manual collection
    */

    if (!items.length) {

      lastProductId = null;

      renderFallback();

      return;
    }


    /*
      Get most recently added cart item.
    */

    var lastItem =
      items[items.length - 1];


    var productId =
      lastItem.product_id;


    /*
      Same product and no force
      → Don't fetch again.
    */

    if (
      !force &&
      productId === lastProductId
    ) {
      return;
    }


    lastProductId =
      productId;


    /*
      Try Shopify related products.
    */

    fetchRecommendations(
      productId
    );
  }


  /* ============================================================
     REFRESH CART FROM SERVER
  ============================================================ */

  function refreshFromServer(force) {

    fetch('/cart.js')

      .then(function (res) {
        return res.json();
      })

      .then(function (cart) {

        updateFromCart(
          cart,
          force
        );

      })

      .catch(function () {

        /*
          Agar cart API fail ho,
          manual collection safe fallback.
        */

        renderFallback();

      });
  }


  /* ============================================================
     DEBOUNCED REFRESH
  ============================================================ */

  function debouncedRefresh() {

    clearTimeout(
      debounceTimer
    );


    debounceTimer =
      setTimeout(
        function () {

          refreshFromServer(false);

        },
        150
      );
  }


  /* ============================================================
     MESSAGE
  ============================================================ */

  function showMessage(
    slide,
    text
  ) {

    var msg =
      slide.querySelector(
        '[data-reco-msg]'
      );


    if (!msg) return;


    msg.textContent =
      text;


    msg.hidden = false;


    setTimeout(
      function () {

        msg.hidden = true;

      },
      2000
    );
  }


  /* ============================================================
     RECOMMENDATION ADD BUTTON
  ============================================================ */

  document.addEventListener(
    'click',
    function (e) {

      var btn =
        e.target.closest &&
        e.target.closest(
          '.cart-reco__add-btn'
        );


      if (
        !btn ||
        btn.disabled
      ) {
        return;
      }


      var variantId =
        btn.getAttribute(
          'data-variant-id'
        );


      var slide =
        btn.closest(
          '.cart-reco__item'
        );


      if (!variantId) {
        return;
      }


      var originalText =
        btn.textContent;


      btn.disabled = true;

      btn.textContent =
        'Adding...';


      fetch(
        '/cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body:
            JSON.stringify({
              id: variantId,
              quantity: 1
            })
        }
      )

        .then(function (res) {

          return res
            .json()
            .then(function (data) {

              if (!res.ok) {
                throw data;
              }

              return data;

            });

        })


        .then(function () {

          btn.textContent =
            'Added \u2713';


          return fetch(
            '/cart.js'
          )
            .then(function (res) {
              return res.json();
            });

        })


        .then(function (cart) {

          document.dispatchEvent(
            new CustomEvent(
              'cart:updated',
              {
                detail: {
                  cart: cart
                }
              }
            )
          );


          if (
            window.FSB &&
            typeof window.FSB.update ===
              'function'
          ) {

            window.FSB.update(
              cart.total_price
            );
          }


          setTimeout(
            function () {

              btn.disabled = false;

              btn.textContent =
                originalText;

            },
            1200
          );

        })


        .catch(function (err) {

          var message =
            (
              err &&
              err.description
            ) ||
            'Could not add, try again';


          showMessage(
            slide,
            message
          );


          btn.disabled = false;

          btn.textContent =
            originalText;

        });

    }
  );


  /* ============================================================
     POLLING
  ============================================================ */

  function startPolling() {

    clearInterval(
      pollTimer
    );


    pollTimer =
      setInterval(
        function () {

          refreshFromServer(false);

        },
        1500
      );
  }


  /* ============================================================
     INIT
  ============================================================ */

  function init() {

    hookCartDrawerRender();


    /*
      IMPORTANT:

      First show manual collection by default.
      Then check cart and try smart recommendations.
    */

    renderFallback();


    refreshFromServer(true);


    document.addEventListener(
      'cart:updated',
      function (e) {

        var cart =
          e.detail &&
          (
            e.detail.cart ||
            e.detail
          );


        if (
          cart &&
          cart.items
        ) {

          updateFromCart(
            cart,
            false
          );

        } else {

          debouncedRefresh();

        }

      }
    );


    document.addEventListener(
      'cart:refresh',
      debouncedRefresh
    );


    /*
      Fallback safety net.
    */

    startPolling();


    /*
      In case cart-drawer custom element
      is registered slightly later.
    */

    setTimeout(
      hookCartDrawerRender,
      500
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();